import Button from '@/components/general/Button';
import i18next from 'i18next';
import useItemContext from '@/hooks/useItemContext';
import useCart from '@/hooks/useCart';
import { motion } from 'framer-motion';
import { useState } from 'react';
import useAuction from '@/hooks/useAuction';

const ProductEcomAddToCartButton = () => {
    const { item: product } = useItemContext();
    const { auctionOver } = useAuction(product);
    const { addToCart } = useCart();

    const [active, setActive] = useState(false);

    const handleClick = () => {
        if (active) return;
        setActive(true);
        setTimeout(() => setActive(false), 2000); // Reset to ready after animation
        if (product) {
            addToCart(product);
        }
    };

    const cartVariants = {
        ready: { rotate: 0, marginLeft: 0, transition: { duration: 0.1 } },
        active: {
            rotate: -20,
            marginLeft: '100%',
            opacity: 0,
            transition: { duration: 0.6, delay: 0.1, ease: 'easeIn' },
        },
    };

    const textVariants = {
        ready: {
            opacity: 1,
            display: 'inline',
            transition: {
                opacity: { duration: 0.1, delay: 0.1 },
                display: { delay: 0 },
            },
        },
        active: {
            opacity: 0,
            display: 'none',
            transition: {
                opacity: { duration: 0.1 },
                display: { delay: 0.7 },
            },
        },
    };

    const checkVariants = {
        ready: {
            opacity: 0,
            display: 'none',
            transition: { opacity: { duration: 0.1 } },
        },
        active: {
            opacity: 1,
            display: 'inline',
            transition: { opacity: { duration: 0.1, delay: 0.75 } },
        },
    };

    if (auctionOver) {
        return (
            <Button disabled fullWidth>{i18next.t('common:product-tile.sold-out')}</Button>
        );
    }

    return (
        <button
            onClick={handleClick}
            className="bg-white text-[#1D2432] px-6 py-3 rounded-full overflow-hidden flex items-center justify-center space-x-2 w-full relative h-[48px] border-[1px] border-[#D0D5DD]"
        >
            <motion.div
                variants={cartVariants}
                animate={active ? 'active' : 'ready'}
                className="flex-shrink-0"
            >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-[20px]">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 0 0-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 0 0-16.536-1.84M7.5 14.25 5.106 5.272M6 20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm12.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z" />
                </svg>

            </motion.div>

            <motion.span
                variants={textVariants}
                animate={active ? 'active' : 'ready'}
                className="text-[#1D2432] font-[500] text-[14px]"
            >
                {i18next.t('button-text.add-to-cart')}
            </motion.span>

            <motion.span
                variants={checkVariants}
                animate={active ? 'active' : 'ready'}
                className="text-[#1D2432] font-semibold flex items-center absolute"
            >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-[20px]">
                    <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                </svg>

            </motion.span>
        </button>
    );
};

export default ProductEcomAddToCartButton;
